import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

interface FormCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({ label, checked, onChange }) => {
  return <FormControlLabel control={<Checkbox checked={checked} onChange={onChange} />} label={label} />;
};

export default FormCheckbox;
